import Accessor from "@arcgis/core/core/Accessor";
import {
  property,
  subclass,
} from "@arcgis/core/core/accessorSupport/decorators";
import { when } from "@arcgis/core/core/reactiveUtils";
import WebMap from "@arcgis/core/WebMap";
import WebScene from "@arcgis/core/WebScene";
import PortalGroup from "@arcgis/core/portal/PortalGroup";

@subclass("Landing.data.ItemLoader.ItemLoaderViewModel")
export default class ItemLoaderViewModel extends Accessor {
  @property()
  portal: __esri.Portal;

  /** Has the item been instantiated? */
  @property()
  isItemLoaderDone: boolean = false;

  /** Has the instantiated item loaded fully? */
  @property()
  isItemLoaded: boolean = false;

  @property()
  webmap: WebMap;

  @property()
  webscene: WebScene;

  @property()
  group: PortalGroup;

  @property()
  loadedItemType: "webmap" | "webscene" | "group" | "none";

  constructor(params?: any) {
    super(params);

    when(
      () => this?.portal !== undefined,
      () => {
        const { portal } = this;
        const urlParams = new URLSearchParams(window.location.search);
        const webmapId: string = urlParams.get("webmap");
        const websceneId: string = urlParams.get("webscene");
        const groupId: string = urlParams.get("group");
        if (webmapId) {
          this.webmap = new WebMap({
            portalItem: {
              id: webmapId,
              portal,
            },
          });
          this.loadedItemType = "webmap";
        } else if (websceneId) {
          this.webscene = new WebScene({
            portalItem: {
              id: websceneId,
              portal,
            },
          });
          this.loadedItemType = "webscene";
        } else if (groupId) {
          this.group = new PortalGroup({
            id: groupId,
            portal,
          });
          this.loadedItemType = "group";
        } else {
          this.loadedItemType = "none";
        }
        this.isItemLoaderDone = true;

        this._determineIfItemLoaded();
      },
      {
        initial: true,
        once: true,
      }
    );
  }

  getLoadedItem(): __esri.PortalItem | __esri.PortalGroup | null {
    return (
      this?.webmap?.portalItem ??
      this?.webscene?.portalItem ??
      this.group ??
      null
    );
  }

  private async _determineIfItemLoaded(): Promise<void> {
    if (this.loadedItemType === "group" || this.loadedItemType === "none") {
      this.isItemLoaded = true;
    } else if (this.loadedItemType === "webmap") {
      this.webmap
        .loadAll()
        .then(() => {
          when(
            () => this?.webmap?.loaded === true,
            () => {
              this.isItemLoaded = true;
            },
            {
              initial: true,
              once: true,
            }
          );
        })
        .catch((err) => {
          console.error(err);
          this.isItemLoaded = true;
        });
    } else if (this.loadedItemType === "webscene") {
      this.webscene
        .loadAll()
        .then(() => {
          when(
            () => this?.webscene?.loaded === true,
            () => {
              this.isItemLoaded = true;
            },
            {
              initial: true,
              once: true,
            }
          );
        })
        .catch((err) => {
          console.error(err);
          this.isItemLoaded = true;
        });
    }
  }
}
